module.exports = __webpack_public_path__ + "static/media/movielot.f5475d44.png";